<div id="div-background">

  <div id="div-footer">

    <div id="div-left">

      <ion-img [src]="leftShine"></ion-img>

    </div>

    <div id="div-center">

      <div id="div-arrow">
        <ion-img [src]="arrowToon"></ion-img>
      </div>

      <div id="div-buttom">
        <ion-button class="ion-no-padding" fill="clear" (click)="onDismiss()">
          <ion-label>Entendido</ion-label>
        </ion-button>
      </div>
      
    </div>
    
    <div id="div-right">
      
      <ion-img [src]="rightShine"></ion-img>
      
    </div>

  </div>

</div>
